import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import FiltersRow from './filtersRow';

const enhance = compose(
  withNamespaces(['common', 'project']),
);
export default enhance(FiltersRow);
